import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./font.css";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { HelmetProvider } from "react-helmet-async"
declare global {
  interface Window {
    aiptag: any;
    aipDisplayTag: any;
    aipPlayer: any;
  }
}
const rootElement = document.getElementById("root");
ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
    <App />
      </HelmetProvider>
  </React.StrictMode>,
  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
